import React from 'react';
import { Users, MapPin, BookOpen, Settings, LayoutDashboard } from 'lucide-react';
interface SidebarProps {
  currentPath: string;
  onNavigate: (path: string) => void;
}
export function Sidebar({
  currentPath,
  onNavigate
}: SidebarProps) {
  const menuItems = [{
    path: '/dashboard',
    label: 'Training Management Dashboard',
    icon: LayoutDashboard
  }, {
    path: '/trainers',
    label: 'Trainers',
    icon: Users
  }, {
    path: '/venues',
    label: 'Venue',
    icon: MapPin
  }, {
    path: '/training/create',
    label: 'Training Create',
    icon: BookOpen
  }, {
    path: '/settings',
    label: 'Setting',
    icon: Settings
  }];
  return <div className="w-64 bg-white min-h-screen flex flex-col border-r border-gray-200" data-id="element-22">
      <div className="p-6 border-b border-gray-200" data-id="element-23">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/djtvjHJra32VD4mD76XaPX/ud_logo.png" alt="ekseba Uddokta" className="h-12 w-auto" data-id="element-24" />
      </div>
      <nav className="flex-1 p-4" data-id="element-25">
        <div className="space-y-1" data-id="element-26">
          {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = currentPath.startsWith(item.path);
          return <button key={item.path} onClick={() => onNavigate(item.path)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-27">
                <Icon className="w-5 h-5" data-id="element-28" />
                {item.label}
              </button>;
        })}
        </div>
      </nav>
    </div>;
}